export function removeSpecialCharacters(str) {
    return str.replace(/[\\\`\~\!\@\#\$\%\^\&\*\(\)\_\+\-\=\{\}\|\[\]\:\"\;\'\<\>?\,\.\/]/g, '');
}